import React from 'react';

export interface ButtonProps {
	id?: string;
	label?: string;
	children?: React.ReactNode;
	onClick?: () => void;
	enabled?: boolean;
	primary?: boolean;
	small?: boolean;
	className?: string;
	['data-pw']?: string;
}

export const Button: React.FC<ButtonProps> = props => {
	return (
		<button
			id={props.id}
			data-pw={props['data-pw'] ?? props.id}
			disabled={props.enabled === false}
			tabIndex={props.enabled === false ? -1 : undefined}
			className={
				'styled-button font-semibold' +
				(props.primary ? ' primary' : '') +
				(props.enabled === false ? ' disabled' : '') +
				(props.small ? ' small' : '') +
				(props.className ? ` ${props.className}` : '')
			}
			onClick={props.onClick}
		>
			{props.label ?? props.children}
		</button>
	);
};
